<!-- 出库单自动生成 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
    </avue-crud>
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, exportExcel } from "./api";
import {getSearchTimeConfig} from "@/basic-common/util/common";
import { downloadXls } from '@/util/util'

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList},
      exportLoading: false,
      defaultParams: {
        businessType: "2", //必须传且为2 汽车出库
      },
      option: {
        ...this.$store.state.publicOption,
        menu: false,
        addBtn: false,
        column: [
            {
            label: "客户",
            prop: "custNo",
            overHidden: true, // 表格超出隐藏
            type: "select",
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            search: true, // 查询是否显示
          },
          {
            label: '出库单号',
            prop: 'id',
            search: true,
            type:"number",
            controls:false,
          },
          {
            label: '车牌号',
            prop: 'trainNumber',
            search: true,
          },
          {
            label: '计划号',
            prop: 'planNo',
          },
          {
            label: '客户',
            prop: 'custName',
          },
          {
            label: '库区',
            prop: 'locationName',
          },
          {
            label: '物资名称',
            prop: 'cargoName',
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'varName',
              value: 'id'
            },
          },
          {
            label: '空车时间',
            prop: 'emptyTime',
          },
          {
            label: '重车时间',
            prop: 'heavyTime',
          },
          {
            label: '皮重(吨)',
            prop: 'tareWeight',
          },
          {
            label: '毛重(吨)',
            prop: 'grossWeight',
          },
          {
            label: '净重(吨)',
            prop: 'netWeight',
          },
          {
            label: '质检结果', // 0=未质检，1=合格，2=不合格
            prop: 'inspectionResult',
          },
          {
            ...getSearchTimeConfig(),
            paramsKey: ["startTime", "endTime"],
          }
        ]
      },
    }
  },
  mounted() {

  },
  methods: {
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `出库单自动生成_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss">

</style>
